import { NuxtLink } from '#components';
import { LINK_INJECTION_KEY } from '@exfluential/ui';
import { defineNuxtPlugin } from 'nuxt/app';

// Shared @exfluential/ui components render their `to` targets through this.
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.provide(LINK_INJECTION_KEY, NuxtLink);
});
